import React, { Component } from 'react';
import HttpServices from '../../utils/Http.services';
import { checkTranslation } from '../../utils/useful';

class RoomChangeLayout extends Component {
    state = {
        layout: [],
        isLoading: false,
        // checked: {}
    }

    // changeInputValue(target) {
    //     // let checked = this.state.checked
    //     // this.setState({ checked: target })

    //     this.props.changeValue(this.props.header.key, target)
    // }

    componentDidMount() {
        // console.log(this.props.data)
        if (this.props.data) {
            this.setState({ checked: this.props.data })
        }

        this.init(true)
    }


    componentDidUpdate(prevProps) {

        // console.log(this.props.data)

        if (this.state.layout != this.props.header.information.items && this.props.header.information.type === "local") {
            this.setState({ layout: this.props.header.information.items })
        }
    }

    init(mount) {

        // console.log(this.props.data)

        // if(!mount){
        //     this.props.changeValue(this.props.header.key, null, this.props.extra) 
        // }
        if (this.props.header.information) {
            if (this.props.header.information.type === "local") {
                this.setState({ layout: this.props.header.information.items })
                // if (!this.state.checked || this.state.checked == {}) {
                //     this.setState({ checked: this.props.header.information.items[0] })
                // }
            } else if (this.props.header.information.type === "api") {
                this.fetch()
            }
        }

    }



    fetch() {

        // console.log("HERE")
        console.log(this.props.header.information.filter)
        let filter = this.props.header.information.filter
        if (this.props.header.information.sort) {
            filter.sort = this.props.header.information.sort
        }

        for (const [key, value] of Object.entries(filter)) {
            if (/\{\{(.*?)\}\}/.test(value)) {

                if (this.props.variables) {
                    filter[key] = this.props.variables[value.replace(/{/g, '').replace(/}/g, '')]
                }
                // console.log("VAR")
            }
        }

        // console.log(filter)
        // console.log(this.props.variables)
        this.setState({ isLoading: true })
        console.log('req', this.props.header.information.filter)
        HttpServices.request(this.props.header.information.address, filter, (fetchResult, fetchError) => {
            if (fetchError) { return }
            console.log(fetchResult)
            var newData = []
            fetchResult.info.forEach(element => {

                var newTitle = this.spliter(element, this.props.header.information.fields.title)
                var newValue = this.spliter(element, this.props.header.information.fields.value)

                newData.push({ value: newValue, title: newTitle })
            });
            // console.log("NEW DATA")
            // console.log(newData)
            // setTimeout(() => {

            if (this.props.data != null) {
                let found = false
                // console.log(this.props.data)

                newData.forEach(element => {
                    // console.log(element.value)
                    if (element.value == this.props.data) {
                        found = true
                    }

                });

                if (found == false) {
                    // console.log("DWLKFJWLK")
                    // this.props.changeValue(this.props.header.key, null, this.props.extra)
                }

            }


            this.setState({
                layout: newData,
                isLoading: false
            })
            // }, 1000);


        })

    }


    spliter(source, string) {
        var stringArray = string.split('.')
        var finalString = source
        stringArray.forEach(element => {
            if (finalString) {
                finalString = finalString[element]
            }
        });
        return finalString
    }


    conditionalSettings(param, condition) {
        if (this.props.settings) {
            if (this.props.settings[param] === condition) {
                return true
            }
        }
        return false
    }


    changeValue = (e) => {
        console.log(e)
        this.props.changeValue(this.props.header.key, e, this.props.extra)
    }

    render() {
        let dataValue = ''
        if (this.props.data) {
            dataValue = typeof this.props.data == "object" ? (this.props.data._id ?? this.props.data.id) : this.props.data
        }
        console.log('daaaataaaaa', this.props.data)

        return (
            <div className="w-100 h-100">
                {this.state.layout?.map((item, index) => {
                    console.log('object', item)

                    return (
                        <label className="checkbox-container flexcb pt-3" >
                            <div className='flexc'>
                                <input type="checkbox" onChange={() => { this.changeValue(item) }} checked={this.props.data?.title == item.title ? true : false} />
                                <p className="radioMark"></p>
                                <p className="mld-3" style={{ color: '#222' }}>{checkTranslation(item.title)}</p>
                            </div>
                            <img src={item.img} width={item.width} />
                        </label>

                    )
                })}


                {/* <input ref={el => this.input = el} value={this.props.data ? this.props.data : ''} onChange={(e) => this.changeInputValue(e.target)} placeholder={checkTextTranslation(this.props.header.information.placeholder)} className="transpanet-input" /> */}
            </div>
        );
    }
}

export default RoomChangeLayout;